import { Component, OnInit, ViewChild } from '@angular/core';
import { MarketerEntryComponent } from '../marketer-entry/marketer-entry.component';
import { MatDialog, MatTableDataSource, MatPaginator, MatSelect } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { MarketerService } from 'src/app/services/http/business/marketer/marketer.service';
import { ICompany } from 'src/app/interfaces/company';

@Component({
  selector: 'app-marketer-list',
  templateUrl: './marketer-list.component.html',
  styleUrls: ['./marketer-list.component.css']
})
export class MarketerListComponent implements OnInit {

  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  errors = new Array();
  now = new Date();
  selectedCompany: string;
  companyList: ICompany[];

  pageSize: number;
  pageIndex: number;
  displayedColumns: string[] = [
    this.translate.get("label.name"),
    this.translate.get("label.nationalCode"),
    this.translate.get("label.couponTotal"),
    this.translate.get("label.couponUnused"),
    this.translate.get("label.couponUsed"),
    this.translate.get("label.couponExpired"),
    this.translate.get("label.limitationInMonth"),
    "function"
  ];

  constructor(private dialog: MatDialog,
    public translate: TranslateService,
    private companyService: CompanyService,
    private errorService: ErrorsService,
    private marketerService: MarketerService) { }

  ngOnInit() {
    this.getCompanyList();
  }

  getColor(e) {
    if (new Date(e.ExpirationDate) < this.now) {
      return "custom-chips default"
    }
    else {
      switch (e.IsActive) {
        case true:
          return "custom-chips primary";
        case false:
          return "custom-chips accent";
      }
    }
  }

  getExpirationDate(e) {
    return new Date(e.ExpirationDate);
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  add() {
    this.dialog
      .open(MarketerEntryComponent, {
        width: "500px"
      })
      .afterClosed()
      .subscribe(() => {
        this.marketerService.list(this.selectedCompany, null, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
        });
      });
  }

  edit(data: any) {
    this.dialog
      .open(MarketerEntryComponent, {
        width: "500px",
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.marketerService.list(this.selectedCompany, null, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
          this.dataSource = res.DataList;
          this.paginator.length = res.Total;
        });
      });
  }


  //ative(e): void {
  //  let confirm: IConfirm = {
  //    accept: true,
  //    message: e.IsActive
  //      ? this.translate.get("confirm.inActive", {
  //        name: this.translate.get("label.coupon") + " " + "'" + e.CouponCodeReadOnly + "'"
  //      })
  //      : this.translate.get("confirm.active", {
  //        name: this.translate.get("label.coupon") + " " + "'" + e.CouponCodeReadOnly + "'"
  //      }),
  //alert:null,
  //    yesLabel: this.translate.get("label.yes"),
  //    noLabel: this.translate.get("label.no")
  //  };

  //  const dialogRef = this.dialog.open(ConfirmComponent, {
  //    width: "250px",
  //    data: confirm
  //  });

  //  dialogRef.afterClosed().subscribe(result => {
  //    var activate: any = {
  //      IsActive: !e.IsActive,
  //      Id: e.Id
  //    };
  //    if (result) {
  //      this.couponService.activeDeactiveCouponAdmin(activate).subscribe(
  //        res => {
  //          this.paginatorEvent({
  //            pageIndex: this.paginator.pageIndex,
  //            pageSize: this.paginator.pageSize
  //          });
  //        },
  //        err => {
  //          this.errorService.transactionError();
  //        }
  //      );
  //    }
  //  });
  //}

  paginatorEvent(event) {
    this.marketerService
      .list(this.selectedCompany, null, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  loadData(e: MatSelect) {
    this.selectedCompany = e.value;
    this.dataSource = null;
    this.marketerService.list(e.value, null, 1, 20).subscribe(res => {
      this.dataSource = new MatTableDataSource(res.DataList);
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 20;
    }, () => {
    }
    );
  }
}
